import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'
import '../../assets/scripts/jquery.lettering.js'
import '../../assets/scripts/jquery.textillate.js'

$("header .nav ul li").eq(0).addClass("active");

// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
	autoplay: {
        delay: 5000,
        disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
	pagination: {
    el: ".banner .swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".banner .swiper-button-next",
    prevEl: ".banner .swiper-button-prev",
  },
}); 
 
var banner = new Swiper('.section1 .swiper', {
        navigation: {
        nextEl: ".section1 .swiper .swiper-button-next",
        prevEl: ".section1 .swiper .swiper-button-prev",
        }
}); 
$(".swiper-slide .text .drop").hover(function() {
        $(this).parent().find(".content").addClass("active");
},function() {
       $(".swiper-slide .text .content").removeClass("active"); 
})
$(".swiper-nav li").eq(0).addClass("active");
$(".swiper-list .swiper").eq(0).addClass("active");
$(".swiper-nav li").click(function() {
        let index = $(this).index();
        $(this).addClass("active").siblings().removeClass("active");
        $(".swiper-list .swiper").eq(index).addClass("active").siblings().removeClass("active");
})


jQuery(document).ready(function(){
function uc_stacking_cards_elementor_f1561ed_start(){
			

  var objStackingCards = jQuery("#uc_stacking_cards_elementor_f1561ed");
  var objStackingCardsWrapper = objStackingCards.find('.ue_cards_wrapper');
  var objCards = objStackingCards.find('.ue_stacking_card_item');
  var classActive = "ue-active";
  var cardsStartPositions = getCardsStartPositions();
  var isClicked = false;

  //enable stiky position to calculate start position of all items
  enableStickyPos();

  	
	var objStackingCardWidget = new ueStackingCard();
  
    objStackingCardWidget.init("#uc_stacking_cards_elementor_f1561ed");
   
  
      
    var numCards = objCards.length; 

    gsap.registerPlugin(ScrollTrigger);

    objCards.each(function(index0) {
        const card = jQuery(this);
        const index = index0 + 1;
        const reverseIndex0 = numCards - index;

        // Scroll Related Styles
        gsap.to(card[0], {
            duration: 2,
            scale: 1 - (-(-0.03) * reverseIndex0),            rotate: 0 * reverseIndex0,
             opacity: 1,                          filter:  `blur(${reverseIndex0 * 0}px) grayscale(${reverseIndex0 * 30}%)`,
                     
            scrollTrigger: {
                trigger: objStackingCardsWrapper[0],
                start: `${(index0 / numCards) * 100}% top`,  // Start at each card’s section
                end: "bottom center", // End at next wrapper section
                scrub: true,
                onToggle: (self) => {
                  objStackingCards.trigger("ue_stacking_card_change")
                },
                onEnter: function(){          
                },
                onLeaveBack: function(){
                }
            },
        });
    });
                                                                                            
  //end scroll_related_animation  
    
  /**
  * enable sticky position
  */
  function enableStickyPos(){
    if(!objCards || objCards.length == 0)
    return(false);
      
    objCards.css("position", "sticky");
  }   
                                                                                            
  /**
  * gety cards init positions
  */
  function getCardsStartPositions(){
    var cardsStartPositionsArray = [];
     
    if(!objCards || objCards.length == 0)
    return(null);
      
    objCards.each(function(){
      var objCard = jQuery(this);
      var cardOffset = objCard.offset().top;
        
      cardsStartPositionsArray.push(cardOffset);
    });
      
    return(cardsStartPositionsArray);
  }                                                                                        
       
  /**
  * get active index
  */
  function getActiveIndex(){
    var index;
    var objActiveCard = objStackingCards.find("."+classActive);
      
    if(!objActiveCard || objActiveCard.legnth == 0)
      return(null);
      
    index = objActiveCard.index();
    return(index);
  }
  
  /**
  * scroll
  */
  function scrollTo(changePosition, time){
    jQuery('html, body').animate({
        scrollTop: changePosition
    }, time)
  }                                                                                        
    
  //vars
                                                                                                                           
  //events                                                                                        
  objStackingCards.on("uc_change", function(e){
    var activeIndex = getActiveIndex();
	
    if(activeIndex == null)
      return(true);
    
    if(isClicked == true)
      return(true);
    
    isClicked = true;
    
    setTimeout(function(){
    	isClicked = false;
    },200);    
     
    var activeOffset = cardsStartPositions[activeIndex];
      
    //scroll to selected item
    scrollTo(activeOffset, 100);
  });
   
  function initFancyBox(){
        if("false" == "false")
        return(false);

        //init fancybox only on non cloned items
        var fancyLink = objStackingCards.find(".ue-link");

        fancyLink.attr("data-fancybox", "gallery")

        fancyLink.fancybox({
            loop: true,
            arrows : false,
            backfocus: false,         
            touch: false,
            buttons: [
              "close"
            ],          
        });
  } 
   
 initFancyBox();  
    
  var objRemoteOptions = {
    	class_items:"ue_stacking_card_item",
    	class_active:"ue-active",
    	selector_item_trigger:null,
        add_set_active_code:true
  };
      
  						objStackingCards.data("uc-remote-options", objRemoteOptions);
			
			objStackingCards.trigger("uc-object-ready");
			jQuery(document).trigger("uc-remote-parent-init", [objStackingCards]);
			 
             
}if(jQuery("#uc_stacking_cards_elementor_f1561ed").length) uc_stacking_cards_elementor_f1561ed_start();
	jQuery( document ).on( 'elementor/popup/show', (event, id, objPopup) => {
	if(objPopup.$element.has(jQuery("#uc_stacking_cards_elementor_f1561ed")).length) uc_stacking_cards_elementor_f1561ed_start();});
});

			

/* Icon Bullets scripts: */ 


/* entrance animation js*/

	/**
	 * is element in viewport
	 */
   
			



/* Content Slider scripts: */ 

jQuery(document).ready(function(){
function uc_content_slider_new_elementor_45335b5_start(){
			

  var objSlider = jQuery('#slider-uc_content_slider_new_elementor_45335b5');
  var objClonedItems;
  var objAEToggleLinks = jQuery(".toggle-collapse-link");

  function initaeSliderProtection(){
    var objLink = jQuery(this);
    var dataTarget = objLink.data("target");
    var objAeSliders = objSlider.parents(".has_ae_slider ");
    
    if(!objAeSliders || objAeSliders.length == 0)
      return(true);
    
    var objAeSliderId;
    
    objAeSliders.each(function(){
      var objSlider = jQuery(this);
      var attrId = objSlider.attr("id");
      
      if(!attrId || attrId == undefined)
        return(true);
      
      objAeSliderId = attrId;
    });
    
    if(objAeSliderId != dataTarget)
      return(true);    
    
    setTimeout(function(){
      window.dispatchEvent(new Event('resize'));  
    },300);   
  }

  //init protection
  objAEToggleLinks.on("click", initaeSliderProtection);

  function initCarousel(){    
    //cloned items fancybox fix
    var objItems = objSlider.find('.uc_fbps_slide');
    var itemsNum = objItems.length;
    
    //set data index for each origin item
    for(let i=0; i<itemsNum; i++){      
      var objItem = objItems.eq(i);
      
      objItem.attr('data-fancy-index', i);
    }
    
    objSlider.owlCarousel({
      startPosition:0,
      loop:true,
            animateIn: 'fadeIn',
      animateOut: 'fadeOut',
      	
      
      	
      margin:20,
      autoplayHoverPause:true,
      mouseDrag:true,
      touchDrag:true,
      nav:false,
      items:1,
      dots:false,                       
      smartSpeed: 1000,
      autoplay : true,
      autoplayTimeout : 5000,
      navText: ['<i class="fas fa-chevron-left" aria-hidden="true"></i>','<i class="fas fa-chevron-right" aria-hidden="true"></i>']
    });
    
    //wait while carousel init
    setTimeout(function(){      
      var useFancybox = objSlider.data("lightbox");
      
      if(useFancybox == false)
        return(false);
      
      //init fancybox only on non cloned items
      var fancyLink = objSlider.find(".owl-item:not(.cloned) .ue-item-overlay");
      
      fancyLink.attr("data-fancybox", "gallery")
      
      fancyLink.fancybox({
        loop: true,
        arrows : true,
        backfocus: false
      });
      
      //for cloned items find origin items and trigger it
      objClonedItems = objSlider.find(".owl-item.cloned");
      
      objClonedItems.on('click', function() {        
        var objClonedItem = jQuery(this);
        var objClonedItemChild = objClonedItem.find('.uc_fbps_slide');
        var clickedDataFancyIndex = objClonedItemChild.data('fancy-index');
        var objOriginItem = objSlider.find('.owl-item:not(.cloned) [data-fancy-index='+clickedDataFancyIndex+'] .ue-item-overlay');
        
        objOriginItem.trigger('click');
        
        //do nothing with clicked cloned item https://obu.edu/_resources/ldp/galleries/fancybox/
        return(false);        
      });      
    },400);    
  }  

  //pause synced widget
    
  if(typeof UERemoteConnection != "undefined"){
    //init remote api
    var objRemoteConnectionApi = new UERemoteConnection();

    //check if autoplay is true and trigger event 
    function doAction(actionName){

      var syncedParents = objRemoteConnectionApi.getSyncedElements(objSlider);

      if(!syncedParents)
        return(false); 

      var parentsNum = syncedParents.length;

      if(!parentsNum)
        return(false);  

      jQuery.each(syncedParents, function(index, value){      
        var objParent = jQuery(syncedParents[index]);
        var parentSettings = objParent.data("owl.carousel");

        if(!parentSettings)
          return(true);  

        var isPlaying = parentSettings.settings.autoplay;

        if(isPlaying == false)
          return(true);  

        objParent.trigger(actionName);      
      });    
    }

    function onPyramidMouseOver(){    	
      doAction("stop.owl.autoplay");
    }

    function onPyramidMouseOut(){    	
      doAction("play.owl.autoplay");  		
    }

    objSlider.on("mouseover", onPyramidMouseOver);
    objSlider.on("mouseout", onPyramidMouseOut);
  }

      

  //end pause synced widget

  initCarousel();

  objSlider.on("uc_ajax_refreshed",function(){      
    objSlider.trigger('destroy.owl.carousel');      
    initCarousel();      
  });

  			
			objSlider.trigger("uc-object-ready");
			jQuery(document).trigger("uc-remote-parent-init", [objSlider]);
			

}if(jQuery("#uc_content_slider_new_elementor_45335b5").length) uc_content_slider_new_elementor_45335b5_start();
	jQuery( document ).on( 'elementor/popup/show', (event, id, objPopup) => {
	if(objPopup.$element.has(jQuery("#uc_content_slider_new_elementor_45335b5")).length) uc_content_slider_new_elementor_45335b5_start();});
});

$(".section4 ul li").hover(function() {
  $(this).addClass("active1").siblings().addClass("active2");
},function() {
  $(".section4 ul li").removeClass("active1");
  $(".section4 ul li").removeClass("active2");
})


// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
if (s > $(".section4").offset().top + $("header").height()  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s >$(".section4").offset().top + $("header").height()  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})

